import { useQuery } from 'react-query'
import { initTransactionForInstallments } from 'services/loans'
import { QuotedInstallment } from '../payload'

/**
 * Price the selected installments in one call.
 *
 * The commission is charged per installment (2% of the installment, floored
 * and capped), so a five-installment payment carries five fees. The quote is
 * the only place that number can come from, and the member has to see it
 * before approving the payment.
 */
export default function useSetInitPayment(
    poolshipId: number | undefined,
    installments: QuotedInstallment[]
) {
    const ids = installments.map((one) => one.id).join(',')
    const { data, isLoading } = useQuery(
        ['init-transaction-for-installments', poolshipId, ids],
        () => initTransactionForInstallments(poolshipId as number, installments),
        { enabled: Boolean(poolshipId) && installments.length > 0 }
    )
    return { data, isLoading }
}
